import React, { Component } from 'react'
import defaultImg from './../../assets/img/preloaders/locales.jpg'

class LocalesGrid extends Component {
  itemIn(id) {
    const item = document.getElementById('bg-color' + id);
    item.classList.add('bg-hover');

    const puntero = document.getElementById('i' + id);
    puntero.classList.add('puntero-hover');
  }

  itemOut(id) {
    const item = document.getElementById('bg-color' + id);
    item.classList.remove('bg-hover');

    const puntero = document.getElementById('i' + id);
    puntero.classList.remove('puntero-hover');
  }

  startModal(id) {
    const modal = document.getElementById(id);
    modal.classList.add('is-active');
  }

  closeModal(id) {
    const modal = document.getElementById(id);
    modal.classList.remove('is-active');
  }

  item(el) {
    return (
      <div key={el.id} id={`local${el.id}`} className="column is-half-tablet is-half-desktop is-one-third-widescreen grid-item">
        <div className="grid-item-img"
          key={el.id}
          // style={{ backgroundImage: `url(${el.grid_locales_img.sizes.xs})` } }
          style={{ backgroundImage: `${el.grid_locales_img}` ? `url(${el.grid_locales_img.sizes.sm})` : `url(${defaultImg})` }}
          onMouseEnter={() => {this.itemIn(el.id)}}
          onMouseLeave={() => {this.itemOut(el.id)}}
          onClick={() => {this.startModal(`map-locales${el.id}`)}}>

          <div id={`bg-color${el.id}`} className="bg-color"></div>
          <div className="bg-color"></div>
          <div className="grid-item-info">

            <h3>{el.grid_locales_titulo} <i className="puntero fa fa-map-marker" id={`i${el.id}`}></i></h3>
            <p>{el.grid_locales_direccion}</p>
            <p>{el.grid_locales_telefono}</p>
            <p>{el.grid_locales_horario}</p>
          </div>
        </div>

        <div id={`map-locales${el.id}`} className="modal">
          <div className="modal-background" onClick={() => {this.closeModal(`map-locales${el.id}`)}}></div>
          <div className="modal-content">
            <h3>{el.grid_locales_titulo}</h3>
            <iframe title={el.id} frameBorder="0" src={el.grid_locales_ubicacion}></iframe>
          </div>
          <button className="modal-close" onClick={() => { this.closeModal(`map-locales${el.id}`) }}></button>
        </div>

      </div>
    )
  }

  gridItems() {
    return this.props.apiHome.grid_locales ? this.props.apiHome.grid_locales.map(el => this.item(el)) : 'Loading...';
  }

  render() {
    return (
      <section id="js-locales-grid" className="section locales-grid"
        data-aos="fade" data-aos-duration="650" data-aos-delay="360" data-aos-offset="160" data-aos-easing="ease-in-out-quad">
        <div className="container is-fluid">
          <div className="columns locales-grid-content">
            <div className="column is-10 is-offset-1">
              <div className="columns is-multiline">
                {this.gridItems()}
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default LocalesGrid;
